// TODO: refactor validations schemas and centralize validation error messages here

export const VALIDATION_MESSAGES = {
  REQUIRED_FIELD: 'Este campo es requerido',
  INVALID_RUT: 'Rut inválido',
  INVALID_EMAIL: 'Correo electrónico inválido',
} as const;
